module.exports = __webpack_public_path__ + "static/media/7x7-rubber.ae594055.png";